var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9294 0.162109H2.21094L8.22017 7.01134H13.9386L7.9294 0.162109Z",
    fill: "#D45947"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28245 0.162109H3.85938L9.8363 7.01134H12.2917L6.28245 0.162109Z",
    fill: "#C14336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6154 9.59665C14.4216 9.59665 14.26 9.43511 14.26 9.24127V6.81819H7.86311V9.24127C7.86311 9.43511 7.70157 9.59665 7.50773 9.59665C7.31388 9.59665 7.15234 9.43511 7.15234 9.24127V6.46281C7.15234 6.26896 7.31388 6.10742 7.50773 6.10742H14.6154C14.8093 6.10742 14.9708 6.26896 14.9708 6.46281V9.24127C14.9708 9.43511 14.8093 9.59665 14.6154 9.59665Z",
    fill: "#788D9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0678 0.162109H19.7863L13.7771 7.01134H8.05859L14.0678 0.162109Z",
    fill: "#F1786B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7163 0.162109H18.1393L12.1624 7.01134H9.70703L15.7163 0.162109Z",
    fill: "#D45947"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0634 20.8397C14.7034 20.8397 17.6542 17.889 17.6542 14.249C17.6542 10.609 14.7034 7.6582 11.0634 7.6582C7.42344 7.6582 4.47266 10.609 4.47266 14.249C4.47266 17.889 7.42344 20.8397 11.0634 20.8397Z",
    fill: "#FBD984"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0621 18.7708C13.5602 18.7708 15.5852 16.7457 15.5852 14.2477C15.5852 11.7497 13.5602 9.72461 11.0621 9.72461C8.56411 9.72461 6.53906 11.7497 6.53906 14.2477C6.53906 16.7457 8.56411 18.7708 11.0621 18.7708Z",
    fill: "#FDC77C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0652 10.3398L11.9698 13.086H14.8452L12.519 14.7983L13.3913 17.5122L11.0652 15.8322L8.739 17.5122L9.64362 14.7983L7.28516 13.086H10.1928L11.0652 10.3398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievement);
export default __webpack_public_path__ + "static/media/achievement.850f5c14932585a1a2589c2066b05edd.svg";
export { ForwardRef as ReactComponent };